import { render, staticRenderFns } from "./InstallationsSideviewTasksTab.vue?vue&type=template&id=21347bf8&scoped=true&class=fill-height&"
import script from "./InstallationsSideviewTasksTab.vue?vue&type=script&lang=ts&"
export * from "./InstallationsSideviewTasksTab.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationsSideviewTasksTab.vue?vue&type=style&index=0&id=21347bf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21347bf8",
  null
  
)

export default component.exports